import { render, staticRenderFns } from "./print-foot.vue?vue&type=template&id=850d1e4c&scoped=true"
import script from "./print-foot.vue?vue&type=script&lang=js"
export * from "./print-foot.vue?vue&type=script&lang=js"
import style0 from "./print-foot.vue?vue&type=style&index=0&id=850d1e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850d1e4c",
  null
  
)

export default component.exports